import { createUnleash } from 'shared/unleash/hook';

export interface UnleashToggles {
    destinationAutocomplete: boolean;
    currentFilters: boolean;
    hotjar: boolean;
}

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>();

export { UnleashProvider, useUnleash };
